
    var riot = require('riot')
    
riot.tag2('registration-details', '<div show="{loading}" class="alert alert-info"> <h4><span class="fa fa-refresh fa-spin fa-fw"></span> Loading Data</h4> </div> <div show="{!loading}"> <h3>Registration for {registration.event.name} </h3> <p> Event from <dateformat date="{new Date(registration.event.start)}" format="HH:mm dd/MM/yyyy"> </dateformat> to <dateformat date="{new Date(registration.event.end)}" format="HH:mm dd/MM/yyyy"> </dateformat> <div if="{registration.event.external &amp;&amp; registration.event.travel_in &amp;&amp; registration.event.travel_out}"> Travel In <strong> <dateformat date="{new Date(registration.event.travel_in)}" format="d MMM yyyy"></dateformat></strong> - Travel Out <strong> <dateformat date="{new Date(registration.event.travel_out)}" format="d MMM yyyy"></dateformat></strong></div> </p> <div class="form-horizontal"> <formstatic width1="3" width2="9" label="Name" value="{registration.name}"></formstatic> <forminput width1="3" width2="9" label="Phone" onupdate="{handleUpdate}" name="phone1" value="{registration.user.phone1}"></forminput> <forminput width1="3" width2="9" label="Date of Birth" onupdate="{handleUpdate}" name="dob" value="{registration.user.dob ? new Date(registration.user.dob).toISOString().replace(/T.+/,\'\') : \'\'}" type="{\'date\'}"></forminput> <div show="{registration.event.external}"> <formcheckbox width1="3" width2="9" name="accommodation" __checked="{accommodation}" onupdate="{handleUpdate}" value="{registration.accommodation}" label="Accommodation Required"></formcheckbox> <formselect width1="3" width2="9" label="Travelling By" name="transport" options="{transport}" default="Please Select" isrequired value="{registration.transport}" onupdate="{handleUpdate}"> </formselect> <div show="{registration.transport &amp;&amp; registration.transport.match(/train|plane/)}" class="row"> <div class="col-md-6 col-xs-12"> <forminput width1="6" width2="6" name="airport_outbound" label="{registration.transport == \'plane\' ? \'Airport Outbound\' : \'Train Station Outbound\'}" onupdate="{handleUpdate}" value="{registration.airport_outbound}"></forminput> </div> <div class="col-md-6 col-xs-12"> <forminput width1="5" width2="7" name="airport_return" label="{registration.transport == \'plane\' ? \'Airport Return\' : \'Train Station Return\'}" onupdate="{handleUpdate}" value="{registration.airport_return}"></forminput> </div> </div> <div class="row"> <div class="col-md-6 col-xs-12"> <forminput width1="6" width2="6" name="passport_no" label="Passport Number" onupdate="{handleUpdate}" value="{registration.passport_no}"></forminput> </div> <div class="col-md-6 col-xs-12"> <formdate width1="5" width2="7" name="passport_exp" label="Passport Expiry" onupdate="{handleUpdate}" value="{registration.passport_exp ? new Date(registration.passport_exp) : \'\'}" dateformat="dd/MM/yyyy"></formdate> </div> </div> <div class="row"> <div class="col-md-6 col-xs-12"> <forminput width1="6" width2="6" name="passport_name" label="Name on Passport" onupdate="{handleUpdate}" value="{registration.passport_name}"></forminput> </div> <div show="{registration.transport &amp;&amp; registration.transport.match(/train|plane/)}" class="col-md-6 col-xs-12"> <formtextarea width1="5" width2="7" name="travel_req" label="{registration.transport == \'plane\' ? \'Travel To Airport\' : \'Travel To Train Station\'}" onupdate="{handleUpdate}" value="{registration.travel_req}" placeholder="{\'What method of transport are you intending to use when traveling to the \'+(registration.transport == \'plane\' ? \'Airport\' : \'Train Station\')}"></formtextarea> </div> </div> </div> <forminput width1="3" width2="9" name="member_no" label="BAPEN / ESPEN membership Number" onupdate="{handleUpdate}" value="{registration.member_no}" placeholder="(if appropriate)"></forminput> <forminput width1="3" width2="9" name="org_name" label="Your Organisation Name" placeholder="eg. Hospital / Organisation" onupdate="{handleUpdate}" value="{registration.org_name}"></forminput> <formtextarea width1="3" width2="9" name="dietary_req" label="Dietary Requirements" onupdate="{handleUpdate}" value="{registration.dietary_req}" placeholder="eg. Vegetarian, Vegan, Food Allergies"></formtextarea> <formtextarea width1="3" width2="9" name="requests" label="Special Requests" onupdate="{handleUpdate}" value="{registration.requests}" placeholder="i.e. any access or medial needs"></formtextarea> <hr> <div class="btn-toolbar"> <div class="pull-left"> <div onclick="{returnToList}" show="{opts.setview}" class="btn btn-default"> <span class="fa fa-arrow-left"> </span> Return To List</div> </div> <div class="pull-right btn-toolbar"> <confirm onconfirm="{remove}" show="{registration.id}" class="btn btn-danger">Delete Registration</confirm> <div show="{registration.draft!==false}" onclick="{savedraft}" class="btn btn-default">Save Draft</div> <div show="{registration.draft!==false}" onclick="{register}" class="btn btn-primary">Register My Place</div><a show="{opts.showback==\'true\'}" href="{window.location.pathname}" class="btn btn-primary">Close</a> </div> </div> <p><br></p> <p><a href="/contact-us/privacy-policy/" target="_blank">You can find out more about how Fresenius Kabi use your data by reading the Privacy Policy</a></p> </div> </div>', '', '', function(opts) {
var xhr;

xhr = require("../libs/xhr");

this.transport = [
  {
    label: "Road",
    value: "car"
  }, {
    label: "Train",
    value: "train"
  }, {
    label: "Aeroplane",
    value: "plane"
  }
];

this.id = null;

this.on("mount", function() {
  if (opts.event) {
    this.registration = {
      event: opts.event,
      event_id: opts.event.id,
      name: opts.user.name,
      dob: opts.user.dob,
      user: opts.user,
      user_id: opts.user.id,
      org_name: opts.user.org_name,
      draft: true
    };
    this.updateReadOnly();
    return this.update();
  }
});

this.resetReg = (function(_this) {
  return function() {
    return _this.registration = {};
  };
})(this);

this.on("update", function() {
  var ref;
  if (opts.id && +((ref = this.registration) != null ? ref.id : void 0) !== +opts.id && !this.loading) {
    return this.load(opts.id);
  }
});

this.updateReadOnly = (function(_this) {
  return function() {
    if (_this.registration && _this.registration.draft === true) {
      return [].slice.call(_this.root.querySelectorAll("input, textarea, formdate .btn-default")).forEach(function(node) {
        node.removeAttribute('disabled');
        return node.removeAttribute('readonly');
      });
    } else {
      return [].slice.call(_this.root.querySelectorAll("input, textarea, formdate .btn-default")).forEach(function(node) {
        node.setAttribute("disabled", true);
        return node.setAttribute("readonly", true);
      });
    }
  };
})(this);

this.load = (function(_this) {
  return function(id) {
    if (_this.loading) {
      return;
    }
    _this.loading = true;
    _this.update();
    return xhr("get", "/duocms/api/registrations/my/" + id, null, function(res) {
      var registration;
      registration = res.body.data;
      registration.name = (registration.user.title || "") + ' ' + (registration.user.first_name || "") + ' ' + (registration.user.middlenames || "") + ' ' + (registration.user.surname || "");
      registration.dob = registration.user.dob;
      registration.phone1 = registration.user.phone1;
      _this.registration = registration;
      _this.loading = false;
      _this.update();
      return _this.updateReadOnly();
    });
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    if (update.name.match(/phone1|dob/)) {
      _this.registration.user[update.name] = update.value;
    } else {
      _this.registration[update.name] = update.value;
    }
    return _this.update();
  };
})(this);

this.savedraft = (function(_this) {
  return function() {
    _this.registration.draft = true;
    return _this.save();
  };
})(this);

this.register = (function(_this) {
  return function() {
    _this.registration.draft = false;
    return _this.save();
  };
})(this);

this.returnToList = (function(_this) {
  return function() {
    _this.resetReg();
    return opts.setview('list');
  };
})(this);

this.save = (function(_this) {
  return function() {
    if (_this.registration.id) {
      return xhr("put", "/duocms/api/registrations/my/" + _this.registration.id, _this.registration, function(res) {
        if (opts.loadlist) {
          opts.loadlist();
        }
        return setTimeout(function() {
          return _this.resetReg();
        });
      });
    } else {
      return xhr("post", "/duocms/api/registrations/my/", _this.registration, function(res) {
        return window.location.href = "/members/my-registrations/";
      });
    }
  };
})(this);

this.remove = (function(_this) {
  return function() {
    _this.update({
      view: "loading"
    });
    return xhr("DELETE", "/duocms/api/registrations/my/" + _this.registration.id, null, function(res) {
      if (opts.loadlist) {
        return opts.loadlist();
      }
    });
  };
})(this);
});
    
  